import { getModelSlot } from './capabilities';
export const audienceModelSections = [
  {
    label: 'Detection models',
    groups: [
      { id: 'face', label: 'Face-only' },
      { id: 'face-person', label: 'Face + Person' }
    ]
  },
  {
    label: 'Classification models',
    groups: [
      { id: 'age', label: 'Age' },
      { id: 'emotion', label: 'Emotion' },
      { id: 'gender', label: 'Gender' },
      { id: 'full-body-gender', label: 'Full Body Gender' },
      { id: 'mtl', label: 'MTL' }
    ]
  }
];

// Presentation only: preserve model types, array order and all configuration fields.
export const getAudienceModelGroup = model => {
  const type = (model.type || '').toUpperCase();
  const classifiers = {
    AGE: 'age',
    EMOTION: 'emotion',
    GENDER: 'gender',
    GENDER_FULL: 'full-body-gender',
    MTL: 'mtl'
  };
  if (classifiers[type]) return classifiers[type];

  return getModelSlot(model) || 'other';
};
